import type { Completion } from '@codemirror/autocomplete'

export const typeValidatorCompletionList: Completion[] = [
  { label: 'text', type: 'type', info: 'Free text input' },
  { label: 'number', type: 'type', info: 'Numeric input' },
  { label: 'url', type: 'type', info: 'URL input with validation' },
  { label: 'email', type: 'type', info: 'Email address input' },
  { label: 'enum()', type: 'type', info: 'Dropdown with options', apply: 'enum(Option1,Option2)' },
]

export const constraintValidatorCompletionList: Completion[] = [
  { label: 'min()', type: 'keyword', info: 'Minimum value (number)', apply: 'min(0)' },
  { label: 'max()', type: 'keyword', info: 'Maximum value (number)', apply: 'max(100)' },
  { label: 'minLength()', type: 'keyword', info: 'Minimum text length', apply: 'minLength(1)' },
  { label: 'maxLength()', type: 'keyword', info: 'Maximum text length', apply: 'maxLength(255)' },
  {
    label: 'regex()',
    type: 'keyword',
    info: 'Regex pattern validation',
    apply: 'regex("[a-zA-Z]+")',
  },
]

export const modifierValidatorCompletionList: Completion[] = [
  { label: 'default()', type: 'property', info: 'Default value', apply: 'default("")' },
  { label: 'label()', type: 'property', info: 'Display label for the field', apply: 'label("")' },
  { label: 'helper()', type: 'property', info: 'Helper text below the field', apply: 'helper("")' },
]

export const allCompletionList: Completion[] = [
  ...typeValidatorCompletionList,
  ...constraintValidatorCompletionList,
  ...modifierValidatorCompletionList,
]
